<template>
  <content-loader v-if="showContentLoader" />
  <div
    ref="contentRef"
    class="page"
  >
    <riseup-header :flow-config-id="FlowConfigIdType.Etoro" />
    <div ref="iframeContainerRef">
      <iframe
        v-if="htmlContent"
        ref="iframeRef"
        :srcdoc="htmlContent"
        style="width: 100%; border: none;"
        class="html-container"
        sandbox="allow-same-origin allow-popups"
        @load="setupIframeLinkHandler"
      />
    </div>
    <div class="green-bottom">
      <img src="../../assets/etoro-green-footer.svg">
      <p>
        Get a complete view of all your accounts, income and spending, plus personalised insights and real-time recommendations
      </p>
      <button
        class="yellow-button"
        @click="handleTrialButtonClick"
      >
        Get 3 months at 50% off
      </button>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import RiseupHeader from '../Common/RiseupHeader.vue';
import ContentLoader from '../Common/ContentLoader.vue';
import Segment from '../../Segment';
import useContentLoader from '../../composables/useContentLoader';
import { useInsights } from '../../services/insightsService';
import { FlowConfigIdType } from '../../types/otsConfig';
import { useOtsJob } from '../../services/otsConfigService';

const { insights, populateInsights } = useInsights();
const contentRef = ref(null);
const route = useRoute();
const iframeRef = ref(null);
const iframeContainerRef = ref(null);
const { getOtsJobConfig } = useOtsJob();

const otsJobConfig = await getOtsJobConfig();

const {
  showContentLoader,
} = useContentLoader();

const handleTrialButtonClick = () => {
  Segment.trackUserInteraction('OtsStartTrialClicked');
  window.location.href = 'https://start.letsriseup.com/?utm_source=ots&coupon=promo_1Px7hrI1mBb8n2B7hP67Vjd0';
};
const htmlContent = ref('');
onMounted(async () => {
  const queryParam = route.query || null;

  if (!insights.value || insights.value.length === 0) {
    await populateInsights(otsJobConfig.jobId);
  }
  htmlContent.value = `
  <!DOCTYPE html>
  <html>
    <head>
      <style>
        body {
          margin: 0;
        }
        body > :first-child {
          padding-bottom: 80px !important; /* Adjust as needed */
          font-family: 'CircularStd', sans-serif !important;
        }
      </style>
    </head>
    <body>
      ${insights.value[0]?.html}
    </body>
  </html>
`;

  Segment.trackUserGot('EtoroOtsCustomSuccessPageEntered', { fromEmail: queryParam ? queryParam.fromEmail : false, otsJobConfig });

  adjustIframeHeight(); // Initial adjustment
  window.addEventListener('resize', adjustIframeHeight);
});

const adjustIframeHeight = () => {
  if (iframeRef.value && iframeRef.value.contentWindow) {
    setTimeout(() => {
      const iframeDocument = iframeRef.value.contentWindow.document;
      const iframeHeight = iframeDocument.documentElement.scrollHeight || iframeDocument.body.scrollHeight;
      console.log('iframeHeight', iframeHeight);

      iframeContainerRef.value.style.height = `${iframeHeight}px`;
      iframeRef.value.style.height = `${iframeHeight}px`;
    }, 100); // Adjust delay as needed
  }
};

const setupIframeLinkHandler = () => {
  if (iframeRef.value && iframeRef.value.contentWindow) {
    const iframeDocument = iframeRef.value.contentWindow.document;
    const links = iframeDocument.getElementsByTagName('a');

    Array.from(links).forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        window.open(link.href, '_blank');
      });
    });
  }

  adjustIframeHeight();
};

</script>

<style lang="scss" scoped>
@import '../../scss/riseup-vars';

.content {
  margin-top: 30px;
  padding-left: 25px;
  padding-right: 25px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.page {
  background-color: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  scroll-behavior: smooth;
}

.blue-button {

}

.green-bottom {
  margin: 0 auto;
  width: 90%;
  background-color: #205441;
  border-radius: 40px;
  justify-content: flex-start;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px;
  margin-bottom: 20px;
}

.green-bottom .yellow-button {
  background-color: #FFCF03;
  border-radius: 65px;
  color: white;
  border: none;
  margin-top: 34px;
  cursor: pointer;
  font-size: 15px;
  font-family: CircularStdBook;
  font-weight: 900;
  height: 52px;
  margin-bottom: 10px;
  color: #205441;
  box-shadow: 0px 12px 24px rgba(32, 33, 37, 0.12);
  width: 100%;
}

.green-bottom img {
  width: 100%;
}

.green-bottom p {
  color: white;
  font-size: 16px;
  font-family: CircularStd;
  line-height: 28px;
  word-wrap: break-word;
  width: 100%;
  margin-top: 36px;
}

.html-container {
  width: 100%;
}
</style>
